<ami-dialog-message [setting]="message"></ami-dialog-message>
<ami-table-actions
  [settings]="table.settings"
  [data]="table.data"
  [actions]="table.actions"
  (action)="onReciveAction($event)"
></ami-table-actions>


<div *ngIf="idDocument">
  <pg-purchases-details
    (onHideData)="idDocument=undefined"
    [idDocument]="idDocument"
  >
  </pg-purchases-details>
</div>
